// extracted by mini-css-extract-plugin
module.exports = {"gradientHeader":"Header_gradientHeader__beQhC","logo":"Header_logo__BT5P2","submenuHeader":"Header_submenuHeader__x6U4c"};